import { Checkbox, FormControlLabel, Paper, styled } from '@mui/material';

import DraggableArea from './DraggableArea';
import { DragDropElementTree } from './FileExportSelector';

interface DraggableElementProps {
  item: DragDropElementTree;
  indexedElement: number;
  onChangeValue: (itemId: string) => void;
}

export const DraggableElement = ({ item, indexedElement, onChangeValue }: DraggableElementProps) => {
  const BootstrapPaperItem = styled(Paper)(() => ({
    lineHeight: '30px',
    width: '250px',
    fontSize: '18px',
    paddingLeft: '8px',
  }));

  return (
    <DraggableArea item={item} indexedElement={indexedElement}>
      <BootstrapPaperItem elevation={8}>
        <FormControlLabel
          control={<Checkbox checked={item.isSelected} onChange={() => onChangeValue(item.id)} />}
          label={item.name}
        />
      </BootstrapPaperItem>
    </DraggableArea>
  );
};
export default DraggableElement;
